import { Chip, SearchCombobox, type ComboOption } from '@zarya/ui';
import { t } from '@app/i18n';
import s from './Approvals.module.css';

export interface FilterComboProps {
  label: string;
  placeholder: string;
  options: ComboOption[];
  value: string | null;
  onChange: (value: string | null) => void;
}

/**
 * Combobox de filtro das duas abas (motivo em Pendentes, status no Histórico).
 * Nada de `<select>` nativo — combobox pesquisável, como manda o CLAUDE.md.
 */
export function FilterCombo({ label, placeholder, options, value, onChange }: FilterComboProps) {
  return (
    <div style={{ minWidth: 220 }}>
      <SearchCombobox
        label={label}
        placeholder={placeholder}
        searchPlaceholder={t('approvals.filters.searchPlaceholder')}
        options={options}
        value={value}
        onChange={onChange}
        size="sm"
        clearable
      />
    </div>
  );
}

export interface ChipIdentityProps {
  /** `identity_slug` da primeira linha da resposta; `null` quando a fila veio vazia. */
  slug: string | null;
  onRemover: () => void;
}

/**
 * Chip do filtro `?identidade=` — quem chega do rodapé de T5 («Ver aprovação
 * pendente») quer a fila **daquela** identidade, e precisa ver que a fila está
 * recortada e como voltar à inteira.
 *
 * O nome sai da própria resposta, não de uma segunda chamada: a fila já traz
 * `identity_slug` em toda linha. Sem linha não há nome — e afirmar um slug que
 * ninguém leu seria pior que o rótulo genérico —, então o chip diz «Identidade
 * filtrada» e mantém o ×, que é o que a pessoa precisa ali.
 */
export function ChipIdentity({ slug, onRemover }: ChipIdentityProps) {
  return (
    <Chip
      icon="robot"
      onRemove={onRemover}
      removeLabel={t('approvals.filters.identityChip.remove')}
    >
      {slug
        ? t('approvals.filters.identityChip', { slug })
        : t('approvals.filters.identityChip.unknown')}
    </Chip>
  );
}

export interface NoteCountProps {
  exibidas: number;
  total: number;
  sufixo: string;
}

/** `{n} de {m} pendentes · mais antigas primeiro` (§2.3). */
export function NoteCount({ exibidas, total, sufixo }: NoteCountProps) {
  return (
    <span className={s.nota}>
      {t('approvals.filters.note', { shown: exibidas, total, suffix: sufixo })}
    </span>
  );
}
